import { useState } from 'react';
import { Input, Button, Tag, Space } from 'antd';
import { PlusOutlined, CloseOutlined } from '@ant-design/icons';

export const ListInputComponent = ({ value, onChange, setting }) => {
	const listArray = value || [];
	const [inputValue, setInputValue] = useState('');
	const [validationError, setValidationError] = useState('');
	const isHashtagList = setting.id === 'recognitionHashtags';

	const handleAddItem = () => {
		let processedValue = inputValue.trim();

		if (isHashtagList) {
			// Remove any '#' characters to be forgiving
			processedValue = processedValue.replace(/#/g, '');

			const isValid = /^[a-zA-Z0-9]+$/.test(processedValue);

			if (!isValid && processedValue.length > 0) {
				setValidationError(
					'Hashtags must not contain any spaces or special characters.'
				);
				return;
			}
		}

		if (processedValue && !listArray.includes(processedValue)) {
			const newValue = [...listArray, processedValue];
			onChange?.(newValue);
			setInputValue('');
			setValidationError('');
		}
	};

	const handleRemoveItem = (itemToRemove) => {
		const newValue = listArray.filter((item) => item !== itemToRemove);
		onChange?.(newValue);
	};

	const handleInputChange = (e) => {
		const newValue = e.target.value;
		setInputValue(newValue);

		if (validationError) {
			setValidationError('');
		}
	};

	const handleInputKeyPress = (e) => {
		if (e.key === 'Enter') {
			e.preventDefault();
			handleAddItem();
		}
	};

	return (
		<div>
			<div style={{ marginBottom: '8px' }}>
				<Space.Compact
					style={{ width: '100%', maxWidth: '350px', height: '32px' }}
				>
					<Input
						value={inputValue}
						prefix={isHashtagList ? '#' : null}
						onChange={handleInputChange}
						onKeyDown={handleInputKeyPress}
						placeholder={
							isHashtagList ? 'Enter new hashtag' : 'Enter category name'
						}
						status={validationError ? 'error' : ''}
						style={{
							borderTopLeftRadius: '8px',
							borderBottomLeftRadius: '8px',
						}}
					/>
					<Button
						type="primary"
						icon={<PlusOutlined />}
						onClick={handleAddItem}
						disabled={
							!inputValue.trim() ||
							listArray.includes(
								isHashtagList
									? inputValue.trim().replace(/#/g, '')
									: inputValue.trim()
							)
						}
						style={{
							borderTopRightRadius: '8px',
							borderBottomRightRadius: '8px',
						}}
					>
						Add
					</Button>
				</Space.Compact>
			</div>

			{validationError && (
				<div
					style={{
						color: '#ff4d4f',
						fontSize: '12px',
						marginTop: '4px',
					}}
				>
					{validationError}
				</div>
			)}

			{listArray.length > 0 && (
				<div style={{ marginTop: '8px' }}>
					{listArray.map((item, index) => (
						<Tag
							key={index}
							closable
							onClose={(e) => {
								e.preventDefault();
								handleRemoveItem(item);
							}}
							closeIcon={<CloseOutlined />}
							style={{ marginBottom: '4px', marginRight: '4px' }}
						>
							{isHashtagList ? '#' : ''}
							{item}
						</Tag>
					))}
				</div>
			)}

			{listArray.length === 0 && (
				<div
					style={{
						color: '#595959',
						fontSize: '13px',
						fontStyle: 'italic',
						marginTop: '4px',
					}}
				>
					{isHashtagList ? 'No hashtags added yet' : 'No categories added yet'}
				</div>
			)}
		</div>
	);
};
